import { I18nStatic } from "plugins/i18n-js"

// eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
let resolveReadyPromise = function(..._args: any[]) {}
const i18nReadyPromise =  new Promise<I18nStatic>((resolve, _reject) => {
  resolveReadyPromise = resolve
})

export async function whenI18nReady(): Promise<I18nStatic> {
  return await i18nReadyPromise
}

export function markI18nAsReady(I18n: I18nStatic) {
  resolveReadyPromise(I18n)
}
